export default (Vue) => {
  Vue.directive("preventReClick", {
    bind(el) {
      el.addEventListener("click", () => {
        if (!el.disabled) {
          el.disabled = true;
          el.style.cursor = "not-allowed";
          setTimeout(() => {
            el.style.cursor = "pointer";
            el.disabled = false;
          }, 1500);
        }
      });
    },
  });
};
